export const header = {
    account: 'Account Details',
    logout: 'Log Out',
    createAccount: 'Create Account',
    security: 'Security'
}

export const detail = {
    carbonProject: 'Carbon Project',
    projectDetail: 'Project Detail',
    title: 'RIAU ECOSYSTEM RESTORATION CARBON PROJECT',
    value: 'Project Origin: ',
    maptitle: 'Project Summary',
    projectid: 'Project ID:',
    pjname: 'Project Name:',
    country: 'Country:',
    pjtype: 'Project Type:',
    projectstatus: 'Project ID in Originating Registry:',
    pjstate: 'Province/State:',
    est: 'Project Developer/Proponent:',
    pj3rd: 'Project 3rd-Party Verifier:',
    csards: 'Credit Standard:',
    cmlogy: 'Project Methodology:',
    pjststus: 'Project Status:',
    cpiod: 'Crediting Period:',
    asits: 'Annual Credits (estimated):',
    nfdt: 'NFDT™ Address:',
    text_title: 'Description',
    text_banner: 'The Riau Ecosystem Restoration Carbon Project seeks to protect and restore 130,090 ha of peatland ecosystem located in the Republic of Indonesia while at the same time preserving biodiversity and enhancing local livelihoods. The Project will avoid 78,425 ha of forest clearing and conversion to an industrial forestry plantation. The Project is on the island of Sumatra and in the Province of Riau. Specifically, it is located on the Kampar Peninsula, which is a rain-fed peatland forest made up of four former logging concessions. Through the REDD+ process of avoided planned deforestation and wetlands conservation and restoration, the Project will be preserving the remaining peat swamp forests by preventing their conversion to forestry plantations.',
    issuancelist: 'Credit Issuance',
    projectlist: 'Project Documents',
    vin: 'Vintage',
    quantity: 'Quantity',
    issdate: 'Issuance Date',
    doname: 'Document Name',
    dotype: 'Document Type',
    update: 'Update Date',
    view: 'View',
    steps_one: 'Project Information Imported',
    steps_two: 'National Registration Application Filed',
    steps_three: 'Application Documents Submitted',
    steps_four: 'Application under Review by Registry',
    steps_five: 'Application Approved',
    steps_six: 'Project NFDT Created'
}

export const login = {
    title: 'MetaVerse Green Carbon Registry',
    tips: 'A Digital Registry Powered by the MetaVerse NFDT™ Technology',
    login: 'Log In',
    username: 'Username',
    Password: 'Password',
    Forgot_Your_Password: 'Forgot Your Password?',
    FA: '2FA',
    Forgot_Your_FA_Code: 'Forgot Your 2FA Code?',
    LogIn: 'Log In',
    SignUp: 'Sign up'
}

export const carbonIndex = {
    bg_title_More: 'National Carbon Credit Registry',
    bg_title: 'National Carbon Credit Registry',
    tips: 'A Digital Registry Powered by MVGX Technology',
    Total_Credits_Registered: 'Total Credits Issued',
    Total_Projects_Registered: 'Total Projects Registered',
    Native_Registry_Credits: 'Native Registry Credits',
    Tokenized_Credits: 'Tokenized Credits',
    CNTS: 'CNTs',
    C_CNTS: 'C-CNTs',
    Number_of_Registered_Users: 'Number of Registered Users',
    Connected_Registries: 'Connected Registries',
    Connected_Exchanges: 'Connected Exchanges',
    Carbon_Credit_Registry: 'Carbon Credits',
    Carbon_Footprint_Registry: 'Carbon Footprint',
    Carbon_Neutrality_Registry: 'Carbon Neutrality',
    Carbon_Reporting: 'Carbon Reporting',
    Exchange_Service: 'Exchange as a Service',
    ID: 'ID',
    Name: 'Name',
    Country: 'Country',
    Quantity: 'Estimated Annual Credits',
    Date_Issued: 'Date Issued',
    Data_Origin: 'Data Origin',
    cpiod: 'Crediting Period',
    Carbon_Credits_Overview: 'Carbon Credits Overview',
    Total_Credits_Registered: 'Total Credits Issued',
    Native_Registry_Credits_Issued: 'Native Registry Credits Issued',
    CNTs: 'CNTs',
    Pending_Credits: 'Pending Credits',
    Retired_Credits: 'Frozen Credits',
    Credits_Retired: 'Cancelled Credits',
    Tokenized_Credits: 'Tokenized Credits',
    C_CNTs: 'C-CNTs',
    Current_Year_Total_Credits: 'Current Year Total Credits',
    Carbon_Credit_Registry_Overview: 'Carbon Credit Registry Overview',
    Carbon_Projects: 'Carbon Projects',
    Carbon_Credits: 'Carbon Credits',
    Registry_Carbon_Projects: 'Registry Carbon Projects',
    Registry_Carbon_Credits: 'Registry Carbon Credits',
    Carbon_Credit_Transactions: 'Carbon Credit Transactions',
    logOUt: 'Log Out',
    NAME: 'NAME',
    Project_Type: 'Project Type',
    Methodology: 'Methodology',
    Country: 'Country',
    Search: 'Search',
    Reset_Search: 'Reset Search',
    Carbon_Projects_Overview: 'Carbon Projects Overview',
    Total_Projects_Registered: 'Total Projects Registered',
    Imported_Projects: 'Introduced Projects',
    Projects_with_Credits: 'Projects with Credits',
    Developing_Native_Registry_Projects: "Developing Projects on the National Registry",
    Project_Documents_Submitted: 'Project Documents Submitted',
    Project_in_Implementation: 'Projects in Implementation',
    // Projects_with_Credits_Pending: 'Projects with Credits Pending',
    Projects_Registries: "Projects with Information Imported",
    Projects_Imported_and_Registered: "Projects Filed for National Registration",
    Projects_under_Review: 'Projects under Review for National Registration',
    Projects_Registered_Review: 'Projects Registered and with NFDT Issued',
    Project_Documents_Approved: 'Project Documents Approved',
    Projects_Verification: 'Project Registered',
    Projects_with_Credits_Granted: "Projects with Credits Granted",
    Project_with_Credits_Pending: 'Projects with Credits Issued by National Registry',
    Project_including: 'Projects with Pending Credits',
    Tokenize: 'Search Projects on the Registry',
    Credits_Adjustments: 'Projects Introduced from External Registries',
    Generate_CNTs: 'Projects Introduced by Project Proponents from CMS-CC',
    Generate_C_CNTs: 'Manage the Project Approval Process',
    OwnershipTrades: 'Domestic Transactions of Conventional Carbon Credits',
    Corresponding_Adjustments: 'Domestic Transactions of Tokenize Carbon Credits',
    Domestic: 'Make Corresponding Adjustment of ITMOs',
    Permanent: 'Freeze Carbon Credits for CNT or C-CNT Generation',
    Cancel_Carbon: "Cancel Carbon Credits",
    noData: 'Click "Search" button on the left to display results.',
    three_one: 'Issue Conventional Carbon Credits',
    three_two: 'Tokenize Carbon Credits',
    three_three: 'Manage Carbon Credits',
    three_four: 'Search Carbon Credits on the Registry',
    Initiate_New_Projects: 'Initiate a New Project',
    new_Project_title: 'The New Project Development Process',
    enter: 'Please enter',
    Investment_Objective: 'Investment Objective',
    Project_Name: 'Project Name',
    Country: 'Country',
    Project_Developer: 'Project Developer/Proponent',
    Credit_Standards: 'Credit Standards',
    Crediting_Period: 'Crediting Period',
    Investor_Qualification: 'Investor Qualification',
    Project_Type: 'Project Type',
    Province_State: 'Province/State',
    FriendShipCountryMena: 'MENA',
    FriendShipCountryAsean: 'ASEAN',
    mena: 'MENA',
    asean: 'ASEAN',
    Project_Verifier: 'Project 3rd-Party Verifier',
    Credit_Methodology: 'Credit Methodology',
    Annual_Credits: 'Annual Credits (estimated)',
    Document_Upload: 'Document Upload',
    Cancel: 'Cancel',
    Confirm: 'Confirm',
    province: 'Province/State',
    Registered_Carbon_Projects: 'Registered Carbon Projects',
    Registered_Carbon_Projects_CMS_CC: 'Projects Introduced from CMS-CC',
    Registered_Projects: 'Registered Projects Developed on the National Registry',
    Registered_Projects_Introduced: 'Registered Projects Introduced from External Registries',
    Projects_with_Issued_title: 'Domestic Transactions of Conventional Carbon Credits',
    Projects_with_Issued_title_TXT: 'Corresponding Adjustments of Internationally Transferred Mitigation Outcomes (ITMOs) represented by conventional carbon credits will be available when an international agreement on the operational details of this Paris Agreement mechanism is reached.',
    Projects_with_Issued_title_TXT1: 'Corresponding Adjustments of ITMOs represented by tokenized carbon credits or C-CNTs can be made on this Registry for the two countries of the transaction parties, provided that 1) both countries have established their respective national carbon registry; and 2) the two national registries have been connected for Corresponding Adjustments.',
    DateTime: 'Date and Time',
    Buyer: 'Buyer ID​',
    Sell: 'Seller ID​',
    typeOf: 'Type of Credits',
    Transaction: 'Transaction Quantity​',
    transacted: 'Project ID of Transacted Credits​',
    Projects_with_Issued_Carbon_Credits: 'Projects with Issued Carbon Credits',
    three_Carbon_Credits: 'Conventional National Carbon Credits',
    three_CNTs: 'CNTs',
    three_Tokenized_Carbon_Credits: 'Tokenized National Carbon Credits',
    three_C_CNTs: 'C-CNTs',
    external_Registries: 'Projects from External Registries',
    registries_ID: 'Project ID',
    registries_Name: 'Project Name',
    CMCC_registries_Name: 'Project Proponent',
    registries_Ex: 'External Registry',
    CMCC_registries_Ex: 'Project Verifier',
    CMCC_DETAIL_TXT: 'CMS-CC: Carbon Management System-Carbon Credits, a tool powered by the MVGX NFDT™ technology for carbon project proponents and validation/verification bodies to work together efficiently to develop projects and their documentations for registering the project on the National Registry.',
    registries_Exid: 'External Registry ID',
    CMCC_registries_Exid: 'Location Province / State',
    registries_Credits: 'Estimated Credits',
    CMCC_registries_Credits: 'Development Stage',
    registries_CrePer: 'Crediting Period',
    registries_Status: 'Project Status in National Registry',
    three_Token_National: 'Tokenized National Carbon Credits',
    three_Token_Neutrality: 'Carbon Neutrality Tokens (CNTs)',
    three_token_compliance: 'Compliance - Carbon Neutrality Tokens (C-CNTs)',
    steps_Proone: 'Project Selection',
    steps_Protwo: 'Tokenization Request',
    steps_Prothree: 'Tokenizing',
    steps_Profour: 'Tokens lssued with ERC20 Address',
    step_pjid: 'Project ID',
    step_NFDT: 'NFDT',
    step1: 'Step 1:',
    step2: 'Step 2:',
    step3: 'Step 3:',
    step4: 'Step 4:',
    step5: 'Step 5:',
    step6: 'Step 6:',
    step7: 'Step 7:',
    step_one_txt: 'Project Owner Selects Project from Registered Projects',
    step_two_txt: 'Project Owner Submits Tokenization Request',
    step_the_txt: 'Local Exchange or MVGX Undertakes Tokenization',
    step_for_txt: 'Local Exchange or MVGX Issues, and Registry Receives Tokens with ERC20 Address',
    numofcre: 'Number of Credits',
    numofcreid: 'Enter Project ID',
    projectSelection: 'Project Selection',
    ssuanceApplication: 'CNT Issuance Application',
    creditFreeze: 'Permanent Credit Freeze',
    cntDocument: 'CNT Listing Documents',
    cntLssuan: 'Listing Approval and CNT Issuance',
    cntonMvgx: 'CNTs list & Trade on MVGX',
    stepone_banner: 'Project Owner Selects Project from Registered Projects',
    steptwo_banner: 'Project Owner Submits CNT Issuance Application',
    stepthe_banner_two: 'Registry Permanently Freezes Credits and Issues Certificate',
    stepthe_banner: 'Registry Temporarily Freezes Credits and Issues Certificate',
    stepfor_banner: 'Registry Automatically Generates CNT Listing Documents and Submits to MVGX',
    stepfiv_banner: 'MVGX Reviews and Approves the Listing and Issues CNTs',
    stepfix_banner: 'CNTs List and Trade on MVGX',
    three_token_compliance: 'Compliance - Carbon Neutrality Tokens (C-CNTs)',
    Tokenize_Carbon_title: 'Carbon Credits and Tokenization',
    Tokenize_Carbon_title_National: 'National Carbon Credits:',
    Tokenize_Carbon_title_National_one: 'National Carbon Credits are carbon credits issued by the National Registry based on domestic carbon emission mitigation projects.',
    Tokenize_Carbon_title_National_two: 'These projects are registered on the National Registry and have a non-fungible digital twin (NFDT™) on the blockchain.',
    Tokenize_Carbon_title_National_three: 'Each National Carbon Credit represents one tonne of carbon emissions reduced or avoided.',
    Tokenize_Carbon_title_Tokenized: 'Tokenized National Carbon Credits: ',
    Tokenize_Carbon_title_Tokenized_one: 'Tokenized National Carbon Credits are National Carbon Credits that have been tokenized on the blockchain based on the NFDT of the underlying project.',
    Tokenize_Carbon_title_Tokenized_two: ' National Carbon Credit Tokens are digital versions of the National Carbon Credits.',
    Tokenize_Carbon_title_Tokenized_three: 'National Carbon Credit Tokens digitally trace the underlying emission mitigation project.',
    Tokenize_Carbon_title_Tokenized_four: ' Each National Carbon Credit Token represents one tonne of carbon emissions reduced or avoided.',
    Tokenize_Carbon_title_Tokenized_five: ' National Carbon Credit Tokens can be traded only domestically.',
    Tokenize_Carbon_title_Carbon_Neutrality: 'Carbon Neutrality Tokens (CNT™):',
    Tokenize_Carbon_title_Carbon_Neutrality_C: 'Compliance-Carbon Neutrality Tokens (C-CNTs); C-CNTs are similar to CNTs except:',
    Tokenize_Carbon_title_Carbon_Neutrality_one: 'CNTs are tokenized National Carbon Credits that have been permanently frozen on the National Registry. ',
    Tokenize_Carbon_title_Carbon_Neutrality_two: 'Each CNT is a financial security representing the digital depositary receipt (DDR) of one tonne of carbon emissions reduced or avoided.',
    Tokenize_Carbon_title_Carbon_Neutrality_three: ' CNTs are listed and traded on the MetaVerse Green Exchange (MVGX), a digital exchange regulated by the Monetary Authority of Singapore.',
    Tokenize_Carbon_title_Carbon_Neutrality_four: ' CNTs are purchased by international buyers without affecting the accounting of the Nationally Determined Contributions (NDCs) of the country where the underlying carbon emission mitigation projects reside.',
    Compliance_Carbon: 'Compliance-Carbon Neutrality Tokens (C-CNTs); C-CNTs are similar to CNTs except:',
    Compliance_Carbon_one: 'C-CNTs are tokenized National Carbon Credits that have NOT been permanently frozen on the National Registry.',
    Compliance_Carbon_two: 'The transaction of C-CNTs triggers corresponding adjustments of NDC accounting, where the buyer country can reduce while the seller country will increase their respective national emissions figures.',
    owners: 'Owners of National Carbon Credits are able to',
    partially_or: ' partially or wholly transform owned credits',
    into_any: 'into any one or combination of National Carbon Credit Tokens, CNTs, or C-CNTs depending on transaction needs. However, the transformation is',
    irreversible: 'irreversible',
    project_ID: 'Project ID',
    project_NFDT: 'Project NFDT',
    projectNFDT: 'Project NFDT™ Address',
    project_NAME: 'Project Name',
    creditsFrozen: 'Credits to be Frozen',
    acsuff: 'Available Credits Sufficient?',
    rcafreeze: 'Remaining Credits after Freeze',
    documentSubmit: 'Documents Submitted?',
    ssuanceApplication_c: 'C-CNT Issuance Application',
    creditFreeze_c: 'Credit Freeze & Certificate Issuance',
    cntDocument_c: 'C-CNT Listing Documents',
    cntLssuan_c: 'Listing Approval and C-CNT Issuance',
    cntonMvgx_c: 'C-CNTs list & Trade on MVGX',
    cntonad_c: 'Corresponding Adjustment',
    steptwo_banner_c: 'Project Owner Submits C-CNT Issuance Application',
    stepfor_banner_c: 'Registry Automatically Generates C-CNT Listing Documents and Submits to MVGX',
    stepfiv_banner_c: "MVGX Reviews and Approves the Listing and Issues C-CNTs",
    stepfix_banner_c: 'C-CNTs List and Trade on MVGX',
    stepsen_banner_c: 'Registry Makes Corresponding Adjustment whenever C-CNTs are Transacted and the Two Respective National Registries are Operational',
    issue_t_id: 'ID',
    issue_t_name: 'Project Name',
    nfdt_Ledger: 'NFDT Ledger',
    offsetId: 'Offset ID',
    offsetName: 'Offset Name',
    description: 'Description',
    ContractAddress: 'Contract Address',
    ReceiverAddress: 'Receiver Address',
    ISO: 'ISO14064 Certificate',
    ViewCertificate: 'View Certificate',
    NameOfReport: 'Name of Report',
    pas: 'PAS2060 Certificate',
    nfdtName: 'Name',
    nfdtId: 'ID',
    nfdtDate: 'Date',
    Location: 'Location',
    nfdtHash: 'Detail',
    nfdtAction: 'Node',
    view_on_block: 'View on blockchain',
    TransactionHash: 'Transaction hash',
    mvgxID: 'National Registry ID',
    mvgxnAME: 'Project Name',
    mvgxCredits: 'Est Credits',
    mvgxIssuable: 'Issued Credits',
    mvgxIssuable_cra: 'Requested Credit Issuance',
    mvgxIssuabledits: 'Issuable Credits',
    mvgxIssuabledits_cra: 'Issuable Credits Check',
    action_Issue: 'Action',
    action_Credits: 'Issue Credits',
    numberofCredits: 'Number of Credits to be Issued ',
    numberofCreditsP: 'Please Upload Listing Documents',
    issuesTitle: 'Project Carbon Credit Balance',
    issusCon: 'Conventional Credits Issued by External Registry',
    conCredits: 'Conventional Credits Issued by National  Registry',
    tokenCarbon: 'Tokenized Carbon Credits',
    issusCNTs: 'CNTs',
    issusCNTs_C: 'C-CNTs',
    availableCredits: 'Available Credits',
    contractAddress: 'Contract Address',
    transactionHash: 'Transaction Hash',
    receivedWalletAddress: 'Received Wallet Address',
    received_wallet_address: 'Received Wallet Address',
    Action: 'Action',
    issue_t_id: 'ID',
    issue_t_name: 'Project Name',
    nfdt_Ledger: 'NFDT Ledger',
    offsetId: 'Offset ID',
    offsetName: 'Offset Name',
    description: 'Description',
    ContractAddress: 'Contract Address',
    ReceiverAddress: 'Receiver Address',
    ISO: 'ISO14064 Certificate',
    ViewCertificate: 'View Certificate',
    NameOfReport: 'Name of Report',
    pas: 'PAS2060 Certificate',
    nfdtName: 'Name',
    nfdtId: 'ID',
    nfdtDate: 'Date',
    nfdtCountry: 'Country',
    nfdtProjectType: 'Project Type',
    nfdtHash: 'Detail',
    nfdtAction: 'Node',
    view_on_block: 'View on blockchain',
    TransactionHash: 'Transaction Hash',
    received_wallet_address: 'Received Wallet Address',
    Action: 'Action',
    received_wallet_address: 'Received Wallet Address',
    Action: 'Action',
    issue_t_id: 'ID',
    issue_t_name: 'Project Name',
    nfdt_Ledger: 'NFDT Ledger',
    offsetId: 'Offset ID',
    offsetName: 'Offset Name',
    description: 'Description',
    ContractAddress: 'Contract Address',
    ReceiverAddress: 'Receiver Address',
    ISO: 'ISO14064 Certificate',
    ViewCertificate: 'View Certificate',
    NameOfReport: 'Name of Report',
    pas: 'PAS2060 Certificate',
    nfdtName: 'Name',
    nfdtId: 'ID',
    nfdtDate: 'Date',
    nfdtCountry: 'Country',
    nfdtProjectType: 'Project Type',
    nfdtHash: 'Detail',
    nfdtAction: 'Node',
    view_on_block: 'View on blockchain',
    TransactionHash: 'Transaction Hash',
    received_wallet_address: 'Received Wallet Address',
    Action: 'Action',
    Steps: 'Steps',
    Responsible_Parties: 'Responsible Parties',
    Documents_Required: 'Documents Required/Generated',
    NFDT_Node_Address: 'NFDT Node Address',
    documentupload: 'Document Upload',
    Projects_with_Approval_Action_Pending: 'Projects with Approval Action Pending',
    RequestDate: 'Request Date',
    ActionRequested: 'Action Requested',
    ActionRequested_Manage: 'Approval Requested',
    projectId: 'Project ID',
    manProjectName: 'Project Name',
    projectProponent: 'Project Proponent',
    projectvvb: 'Project VVB',
    DocumentsSubmitted: 'Documents Submitted',
    manProjectAddress: 'Project NFDT™ Address',
    TakeAction: 'Take Action',
    Request_more_Info: 'Request more Info ',
    Approve: 'Approve',
    Decline: 'Decline',
    Number_of_Credits: 'Number of Credits',
    Domestic_Transaction: 'Domestic Transactions of Tokenized Carbon Credits',
    NFDT_Address: 'NFDT Address',
    CancellationRequest: 'Cancellation Request',
    CreditCancellation: 'Credit Cancellation',
    CancellationCertificate: 'Cancellation Certificate',
    CancellProjectOwner: 'Project  Owner Submits Credit Cancellation Request',
    CancellRegistry: 'Registry Executes the Cancellation',
    CancellRegistryIssues: 'Registry Issues Cancellation Certificate',
    New_ProjectDetailPDD: 'PDD: Project Development/Description Document;',
    New_ProjectDetailVVB: 'VVB: Validation and Verification Body;',
    Projects_with: 'Projects with Pending Approval Request',
    public: 'Public',
    privary: 'Confidential',
    Other: 'Other',
    ConventionalCarbonCreditTransactions: 'Conventional Carbon Credit Transactions',
    TokenizedCarbonCredit: 'Tokenized Carbon Credit/C-CNT Transactions',
    CorrespondingAdjustments: 'Corresponding Adjustments (CA) for Transactions of Tokenized Carbon Credits or C-CNTs',
    TransactionDateandTime: 'Transaction Date and Time',
    BuyerID: 'Buyer ID',
    BuyerCountry: 'Buyer Country',
    SellerID: 'Seller ID',
    SellerCountry: 'Seller Country',
    TypeofCredits: 'Type of Credits',
    TransactionQuantity: 'Transaction Quantity',
    TransactionNFDTNodeAddress: 'Transaction NFDT Node Address',
    CAApproved: 'CA Approved?',
    TransactionQuantity_title: 'Transaction Confirmation',

}

export const chinaIndex = {
    title: 'International Registry for ',
    title1: 'China Certified Emission Reductions',
    tips: 'A Digital Registry Powered by MVGX Technology',
    login: 'Log In',
    username: 'Username',
    Password: 'Password',
    Forgot_Your_Password: 'Forgot Your Password?',
    FA: '2FA',
    Forgot_Your_FA_Code: 'Forgot Your 2FA Code?',
    LogIn: 'Log In',
    SignUp: 'Sign up'
}

export const chinaCarbonIndex = {
    bg_title: 'International Registry for ',
    bg_title_t: 'China Certified Emission Reductions',
    tips: 'A Digital Registry Powered by MVGX Technology',
    collapse_one_title: 'Registry Overview',
    collapse_two_title: 'Register CCER Credits',
    collapse_three_title: 'Convert CCER Credits to CNTs',
    collapse_four_title: 'List CNTs on MVGX',
    collapse_one_title_con_title: 'About the Registry',
    collapse_one_title_con_title_oHeader: 'This Registry enables CCER owners to',
    collapse_one_title_con_title_oHeader_oneItem_bold: 'Register',
    collapse_one_title_con_title_oHeader_oneItem: 'internationally CCER credits that have been permanently frozen in China;',
    collapse_one_title_con_title_oHeader_twoItem_Convert: 'Convert',
    collapse_one_title_con_title_oHeader_twoItem_CNT: '(CNT™)',
    collapse_one_title_con_title_oHeader_twoItem_regis: 'registered credits into Carbon Neutrality Tokens ',
    collapse_one_title_con_title_oHeader_twoItem_and: 'and ',
    collapse_one_title_con_title_oHeader_threeItem_list: 'List',
    collapse_one_title_con_title_oHeader_threeItem_trade: 'trade',
    collapse_one_title_con_title_oHeader_threeItem: 'CNTs on the MetaVerse Green Exchange (MVGX).',
    collapse_one_title_con_title_twoHeader: 'CCER Credits Registered on the Registry',
    collapse_one_title_con_title_twoHeader_oneItem: 'Registered CCER Credits',
    collapse_one_title_con_title_twoHeader_twoItem: 'CNTs Converted from Registered CCER Credits',
    collapse_one_title_con_title_twoHeader_threeItem: 'CNTs Listed on MVGX',
    collapse_two_title_con_title: 'Enter Project Information',
    title_li: 'Please Refer to the Table below for the Conversion Result.',
    Project_CCER_ID: 'Project CCER ID',
    Project_Name: 'Project Name',
    Credits_for_CNTs_Conversion: 'Credits for CNTs Conversion',
    CCER_Custodian: 'CCER Custodian',
    CNT_Issuer: 'CNT Issuer',
    Credits_Registry_ID: 'Credits Registry ID',
    Project_NFDT_Address: 'Project NFDT™ Address',
    Upload_CCER: 'Upload CCER Purchase and Freeze Certificates',
    Upload_Certificates: 'Upload Certificates',
    submit: 'Submit',
    ccer_credits_information: 'CCER Credits Information',
    Selects_Credits_from_Registered_Projects: 'Selects Credits from Registered Projects',
    select_project_id: 'Credit Registry ID',
    select_NFDT: 'NFDT Address',
    CNT_Address_sel: 'CNT Address',
    enter_number: 'Enter Number of Credits to be Converted',
    your_request: 'Your Request for Converting',
    ccer_credits: 'CCER Credits into CNTs Has Been Received and Approved.',
    Refer: 'Please Refer to the Table below for the Conversion Result.',
    Credits_Converted_for_CNTs: 'Credits Converted for CNTs',
    CNT_Address: 'CNT™ ERC20 Address',
    Selects_CNTs_to_List: 'Selects CNTs to List',
    Enter_Number_of_CNTs_to_List: 'Enter Number of CNTs to List',
    Submit_Listing_Documents_to_MVGX: 'Submit Listing Documents to MVGX',
    Status_CNTs_on_MVGX: 'Status of Your Request to List CNTs on MVGX',
    cntId: 'CNT ID:',
    steps_one: 'Request to List',
    steps_two: 'CNT Listing Documents',
    steps_three: 'Listing Approval',
    steps_four: 'CNTs list & Trade on MVGX',
    step_one: 'Step 1: ',
    step_one_content: 'CNT Owner Submits Request to List',
    step_two: 'Step 2: ',
    step_two_content: 'Registry Automatically Generates CNT Listing Documents and Submits to MVGX',
    step_three: 'Step 3: ',
    step_three_content: 'MVGX Reviews and Approves the Listing',
    step_four: 'Step 4: ',
    step_four_content: 'CNTs List and Trade on MVGX',
    step_Complete: 'Complete',
    View_Listing_Docs: 'View Listing Docs',
    View_Approval_Notice: 'View Approval Notice',
    Pending: 'Pending',

}

export const exchange = {
    CarbonTrading: 'Carbon Trading',
    OrderHistory: 'Order History',
    TradeHistory: 'Trade History',
    OpenPrice: 'Open Price',
    LastPrice: 'Last Price',
    LowPrice: 'Low Price',
    HighPrice: 'High Price',
    BuyPrice: 'Buy Price',
    BuyAmount: 'Buy Amount',
    SellPrice: 'Sell Price',
    SellAmount: 'Sell Amount',
    Order: 'Order',
    Buy: 'Buy',
    Sell: 'Sell',
    Amount: 'Amount',
    LimitPrice: 'Estimated Total',
    OrderType: 'Order Type',
    Skiporderconfirmations: 'Skip order confirmations',
    BuyCNTwithUSD: 'Buy CNT with USD',
    OrderConfirmation: 'Order Confirmation',
    TotalPrice: 'Estimated Total',
    Confirm: 'Confirm',
    OrderID: 'Order ID',
    Time: 'Time',
    Symbol: 'Symbol',
    Amount: 'Amount',
    Balance: 'Balance',
    Price: 'Price',
    Total: 'Total',
    Status: 'Status',
    Fee: 'Fee',
    title_txt: 'Credit Balances on the Registry after the Corresponding Adjustment:',
    TokenizedCredits: '· Tokenized Credits: ',
    CCNTs: '· C-CNTs: '
}

export const createAccount = {
    newUser: 'New user',
    UserName: 'User Name',
    Password: 'Password',
    ConfirmPassword: 'Confirm Password',
    status: 'Status',
    Security: 'Security',
    all: 'ALL',
    view: 'View',
    Create: 'Create',
    Approve: 'Approve',
    verify: 'Verify',
    Certificate: 'Certificate',
    save: 'Save',
    Back: '< Back',
    addUser: 'Add User',
    Id: 'ID',
    tabUserName: 'User Name',
    action: 'Action',
    Edit: 'Edit',
    Delete: 'Delete',

}